/* KissMyCans "Night Ride" — homepage behaviour.
   No dependencies. The 3D viewer and meshes load on demand, only once a can is picked. */
(function () {
  var SW = { black:'#15171b', white:'#e9e6df', red:'#c22118', blue:'#1c47ca',
             grey:'#6f7783', gray:'#6f7783', silver:'#b9c0ca', green:'#1f7a45',
             orange:'#e0651c', yellow:'#e5b528', pink:'#d9528f', purple:'#6c3fc4' };

  /* Colour options are rarely bare words: "Ducati Red", "Ice White", "Black - Original".
     Match on the colour word found anywhere in the name, longest first so
     "light blue" doesn't win over "blue" by accident. */
  var SW_KEYS = Object.keys(SW).sort(function (a, b) { return b.length - a.length; });
  function swatchColour(name) {
    var k = (name || '').toLowerCase().replace(/[^a-z]/g, '');
    if (SW[k]) return SW[k];
    for (var i = 0; i < SW_KEYS.length; i++) if (k.indexOf(SW_KEYS[i]) !== -1) return SW[SW_KEYS[i]];
    return '#7d8795';
  }

  function load(src) {
    return new Promise(function (res, rej) {
      if (!src) return rej();
      if (document.querySelector('script[data-kmc-src="' + src + '"]')) return res();
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.setAttribute('data-kmc-src', src);
      s.onload = function () { res(); };
      s.onerror = function () { rej(); };
      document.head.appendChild(s);
    });
  }

  /* ---------- toast ---------- */
  var toastEl = null;
  function toast(msg) {
    if (!toastEl) {
      var host = document.createElement('div');
      host.className = 'kmc-nr';
      toastEl = document.createElement('div');
      toastEl.className = 'toast kmc-toast';
      toastEl.setAttribute('role', 'status');
      host.appendChild(toastEl);
      document.body.appendChild(host);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastEl._h);
    toastEl._h = setTimeout(function () { toastEl.classList.remove('on'); }, 2200);
  }

  /* ---------- cart ---------- */
  var lastCart = null;
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble > span:first-child, [data-cart-count]')
          .forEach(function (el) { el.textContent = n; });
        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.hidden = false;
        else {
          /* Dawn only renders the bubble when the cart has items — ask it to re-render the icon */
          var icon = document.getElementById('cart-icon-bubble');
          if (icon) {
            fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-icon-bubble' : '/?section_id=cart-icon-bubble')
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var fresh = doc.getElementById('shopify-section-cart-icon-bubble');
                var host = document.getElementById('shopify-section-cart-icon-bubble');
                if (fresh && host) host.innerHTML = fresh.innerHTML;
              }).catch(function () {});
          }
        }
        lastCart = cart;
        document.dispatchEvent(new CustomEvent('kmc:cart', { detail: { cart: cart } }));
        return cart;
      });
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (j) {
      return refreshCartCount().then(function () { return j; });
    });
  }

  /* ---------- quick add buttons (gear cards, extras) ---------- */
  function bindQuickAdd(scope) {
    scope.querySelectorAll('[data-kmc-add]').forEach(function (b) {
      if (b.dataset.kmcBound) return;
      b.dataset.kmcBound = '1';
      b.addEventListener('click', function (e) {
        var id = b.getAttribute('data-kmc-add');
        if (!id) return;                       /* no variant: it's a plain link, let it through */
        e.preventDefault();
        var label = b.textContent;
        b.disabled = true; b.textContent = 'Adding…';
        addToCart(id, 1).then(function () {
          b.textContent = 'Added';
          toast('Added: ' + (b.getAttribute('data-kmc-title') || 'item'));
        }).catch(function (err) {
          toast((err && err.description) ? err.description : 'Could not add that to the cart.');
        }).then(function () {
          setTimeout(function () { b.disabled = false; b.textContent = label; }, 1400);
        });
      });
    });
  }

  /* ---------- hero video ---------- */
  function bindHero(scope) {
    var v = scope.querySelector('.kmc-hero video.bg');
    if (!v || v.dataset.kmcBound) return;
    v.dataset.kmcBound = '1';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var show = function () { v.classList.add('ready'); };
    if (v.readyState >= 3) show(); else v.addEventListener('canplay', show, { once: true });
    v.play().catch(function () {});
  }

  /* ---------- reel (click to play) ---------- */
  function bindReel(scope) {
    var fig = scope.querySelector('.reel');
    if (!fig || fig.dataset.kmcBound) return;
    var vid = fig.querySelector('video'), btn = fig.querySelector('.play');
    if (!vid || !btn) return;
    fig.dataset.kmcBound = '1';
    btn.addEventListener('click', function () {
      if (!vid.querySelector('source') && vid.dataset.src) {
        var s = document.createElement('source');
        s.src = vid.dataset.src;
        if (vid.dataset.type) s.type = vid.dataset.type;
        vid.appendChild(s);
        vid.setAttribute('controls', '');
        vid.load();
      }
      if (!vid.querySelector('source') && !vid.src) { toast('No clip uploaded yet'); return; }
      var mark = function () { fig.classList.add('playing'); };
      var go = function () {
        vid.play().then(mark).catch(function () {
          vid.muted = true;
          vid.play().then(mark).catch(function () { toast('Your browser blocked the video'); });
        });
      };
      vid.muted = false;
      if (vid.readyState >= 2) go(); else vid.addEventListener('loadeddata', go, { once: true });
      vid.addEventListener('error', function () { toast("This browser can't play the clip"); }, { once: true });
    });
  }

  /* ---------- the size picker + 3D configurator ---------- */
  function initPicker(root) {
    if (root.dataset.kmcReady) return;
    var dataEl = root.querySelector('[data-kmc-data]');
    if (!dataEl) return;
    root.dataset.kmcReady = '1';

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form    = root.querySelector('[data-kmc-form]'),
        tiles   = [].slice.call(root.querySelectorAll('.tile')),
        nameEl  = root.querySelector('[data-kmc-name]'),
        fitEl   = root.querySelector('[data-kmc-fit]'),
        priceEl = root.querySelector('[data-kmc-price]'),
        colWrap = root.querySelector('[data-kmc-colours]'),
        colName = root.querySelector('[data-kmc-colname]'),
        swWrap  = root.querySelector('[data-kmc-swatches]'),
        addBtn  = root.querySelector('[data-kmc-add-btn]'),
        vidInput= root.querySelector('[data-kmc-vid]'),
        errEl   = root.querySelector('[data-kmc-err]'),
        stage   = root.querySelector('[data-kmc-stage]'),
        canvas  = root.querySelector('[data-kmc-canvas]'),
        fallback= root.querySelector('[data-kmc-fallback]');

    var current = null, variant = null, viewer = null, viewerTried = false;

    /* Wrong-region size guard. The commonest support problem is a US or Canadian buyer taking the
       500ml holder, because Monster ships there in a 473ml / 16oz can that the 500ml part will not
       hold. Warn on selection and offer the swap in one click. Country comes from the shopper's
       chosen market, which can be wrong, so the tiles also carry a permanent region badge and the
       warning never blocks the sale — it informs, they decide. */
    var NA = { US: 1, CA: 1 };
    var warnEl  = root.querySelector('[data-kmc-fitwarn]'),
        warnTxt = root.querySelector('[data-kmc-fitwarn-txt]'),
        swapBtn = root.querySelector('[data-kmc-fitswap]'),
        country = (root.dataset.country || '').toUpperCase();

    function handleForRegion(reg) {
      for (var h in DATA) if (DATA[h].region === reg) return h;
      return null;
    }
    function paintFitWarning() {
      if (!warnEl || !warnTxt) return;
      var reg = current && current.region;
      if (!reg) { warnEl.hidden = true; return; }

      /* Both Monster sizes always say which can they are for. It only turns into a red warning
         when the shopper's market and the product disagree — an American with the store set to
         Ireland would otherwise see nothing, which is how the wrong size gets ordered. */
      var buyerIsNA = !!NA[country],
          mismatch = country ? ((buyerIsNA && reg === 'row') || (!buyerIsNA && reg === 'na')) : false,
          want = handleForRegion(reg === 'row' ? 'na' : 'row'),
          msg, label;

      if (mismatch) {
        msg = (reg === 'row' ? root.dataset.warnNa : root.dataset.warnRow) || '';
        label = (root.dataset.warnSwap || 'Switch to the one that fits');
        if (want && DATA[want]) label += ': ' + DATA[want].title;
        warnEl.className = 'fitwarn';
      } else {
        msg = (reg === 'row' ? root.dataset.noteRow : root.dataset.noteNa) || '';
        label = (root.dataset.noteSwap || 'Switch to the');
        if (want && DATA[want]) label += ' ' + DATA[want].title;
        warnEl.className = 'fitwarn is-note';
      }
      if (!msg) { warnEl.hidden = true; return; }

      warnTxt.textContent = msg;
      if (swapBtn) {
        if (want && DATA[want]) {
          swapBtn.textContent = label;
          swapBtn.hidden = false;
          swapBtn.onclick = function () {
            var t = root.querySelector('.tile[data-handle="' + want + '"]');
            if (t) { t.click(); t.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
          };
        } else {
          swapBtn.hidden = true;
        }
      }
      warnEl.hidden = false;
    }

    /* Free-gift nudge. The offer itself is run by the gift app, so this never claims the gift
       has been applied unless the cart actually contains a zero-priced line: everything else it
       says is a restatement of the offer, which stays true whatever the app does. */
    var giftEl  = root.querySelector('[data-kmc-gift]'),
        giftTxt = root.querySelector('[data-kmc-gift-txt]'),
        giftNeed = parseInt(root.dataset.giftThreshold, 10) || 2,
        giftOn  = root.dataset.gift === 'true';

    function holdersInCart(cart) {
      var n = 0;
      (cart.items || []).forEach(function (it) {
        if (DATA[it.handle]) n += it.quantity;
      });
      return n;
    }
    function giftInCart(cart) {
      return (cart.items || []).some(function (it) {
        return it.price === 0 && it.quantity > 0;
      });
    }
    function paintGift(cart) {
      if (!giftOn || !giftEl || !giftTxt || !cart) return;
      var n = holdersInCart(cart), got = giftInCart(cart);
      if (got) {
        giftTxt.textContent = 'Free gift pack added to your cart.';
        giftEl.className = 'giftnudge is-won';
        giftEl.hidden = false;
      } else if (n > 0 && n < giftNeed) {
        var left = giftNeed - n;
        giftTxt.textContent = left === 1
          ? 'One more holder and the gift pack is free.'
          : left + ' more holders and the gift pack is free.';
        giftEl.className = 'giftnudge';
        giftEl.hidden = false;
      } else if (n >= giftNeed) {
        giftTxt.textContent = n + ' holders in your cart, so the gift pack is on us.';
        giftEl.className = 'giftnudge is-won';
        giftEl.hidden = false;
      } else {
        giftEl.hidden = true;
      }
    }
    document.addEventListener('kmc:cart', function (e) { paintGift(e.detail.cart); });
    if (giftOn && giftEl) {
      if (lastCart) paintGift(lastCart);
      else refreshCartCount().catch(function () {});
    }

    function setErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    function pickVariant(colour) {
      if (!current) return null;
      var vs = current.variants, i;
      if (colour) {                                  /* honour the colour, sold out or not */
        for (i = 0; i < vs.length; i++) if ((vs[i].colour || '') === colour) return vs[i];
        return null;
      }
      for (i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
      return vs[0] || null;
    }

    function paintPrice() {
      if (!variant || !priceEl) return;
      priceEl.innerHTML = '';
      priceEl.appendChild(document.createTextNode(variant.price || ''));
      if (variant.compare) {
        var s = document.createElement('s');
        s.textContent = variant.compare;
        priceEl.appendChild(s);
      }
      priceEl.hidden = false;
    }

    function selectVariant(v) {
      variant = v;
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; return; }
      if (vidInput) vidInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (colName) colName.textContent = v.colour || '';
      paintPrice();
      if (viewer && v.colour) viewer.colour(v.colour);
      setErr('');
      document.dispatchEvent(new CustomEvent('kmc:selected'));
    }

    function buildSwatches() {
      if (!swWrap) return;
      swWrap.innerHTML = '';
      var seen = {}, any = false;
      current.variants.forEach(function (v) {
        var c = v.colour;
        if (!c || seen[c]) return;
        seen[c] = true; any = true;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'swatch';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', (variant && (variant.colour || '') === c) ? 'true' : 'false');
        b.setAttribute('aria-label', c + (v.available ? '' : ' (sold out)'));
        b.title = c + (v.available ? '' : ' (sold out)');
        b.style.setProperty('--c', swatchColour(c));
        if (!v.available) b.classList.add('is-out');
        b.addEventListener('click', function () {
          [].forEach.call(swWrap.children, function (x) { x.setAttribute('aria-checked', 'false'); });
          b.setAttribute('aria-checked', 'true');
          selectVariant(pickVariant(c) || v);
        });
        swWrap.appendChild(b);
      });
      if (colWrap) colWrap.hidden = !any;
    }

    function ensureViewer() {
      if (!stage || !canvas || viewerTried) return Promise.resolve();
      viewerTried = true;
      return load(root.dataset.viewerSrc)
        .then(function () { return load(root.dataset.modelsSrc); })
        .then(function () {
          if (window.KMCViewer && window.KMC_MODELS) viewer = window.KMCViewer(canvas, window.KMC_MODELS);
          if (!viewer) stage.classList.add('nogl');
        })
        .catch(function () { stage.classList.add('nogl'); });
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        var d = DATA[t.dataset.handle];
        if (!d) return;
        tiles.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        current = d;
        if (nameEl) nameEl.textContent = d.title;
        if (fitEl) fitEl.textContent = d.fit || '';
        if (form) { form.classList.add('on'); form.setAttribute('aria-disabled', 'false'); }
        selectVariant(pickVariant(null));
        buildSwatches();
        if (fallback && d.image) fallback.src = d.image;
        if (stage) {
          ensureViewer().then(function () {
            if (viewer && d.model) {
              if (!viewer.show(d.model)) stage.classList.add('nogl');
              else if (variant && variant.colour) viewer.colour(variant.colour);
            } else if (!viewer) {
              stage.classList.add('nogl');
            }
          });
        }
        paintFitWarning();
        if (window.innerWidth < 820 && form) form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    if (stage) stage.addEventListener('pointerdown', function () { stage.classList.add('touched'); }, { once: true });

    if (form) form.addEventListener('submit', function (e) {
      if (!variant || !variant.available) { e.preventDefault(); return; }
      if (!window.fetch) return;                     /* no fetch: let the browser post the form */
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      addToCart(variant.id, 1).then(function () {
        addBtn.textContent = 'Added';
        toast('Added: ' + current.title + ', ' + (variant.colour || '').toLowerCase());
      }).catch(function (err) {
        setErr((err && err.description) ? err.description : 'Could not add that to the cart.');
      }).then(function () {
        setTimeout(function () {
          addBtn.disabled = false;
          if (variant) addBtn.textContent = 'Add to cart';
        }, 1400);
      });
    });

    /* Sticky bar on phones. It is a checkout bar, not a second add-to-cart: the page already has
       an Add to cart button, so duplicating it was just taking up room. It stays out of the way
       until there is something in the cart, then it shows what is in there and goes to the cart. */
    if (root.dataset.sticky === 'true' && !document.querySelector('.kmc-sticky')) {
      var barHost = document.createElement('div');
      barHost.className = 'kmc-nr';
      var bar = document.createElement('div');
      bar.className = 'sticky kmc-sticky';
      bar.hidden = true;
      bar.innerHTML = '<div class="s-txt"><small></small><b></b></div>' +
                      '<a class="btn btn-red btn-sm" href="' +
                      ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart') +
                      '">Checkout</a>';
      barHost.appendChild(bar);
      document.body.appendChild(barHost);
      var sSmall = bar.querySelector('small'),
          sBig   = bar.querySelector('b');

      function paintSticky(cart) {
        var n = cart ? cart.item_count : 0;
        if (!n) {
          bar.hidden = true;
          document.documentElement.classList.remove('kmc-has-sticky');
          return;
        }
        sSmall.textContent = 'In your cart';
        sBig.textContent = n === 1 ? '1 item' : n + ' items';
        bar.hidden = false;
        document.documentElement.classList.add('kmc-has-sticky');
      }
      document.addEventListener('kmc:cart', function (e) { paintSticky(e.detail.cart); });
      if (lastCart) paintSticky(lastCart);
      else refreshCartCount().catch(function () {});
    }
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-kmc-picker]').forEach(initPicker);
    bindQuickAdd(scope);
    bindHero(scope);
    bindReel(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.KMCNight = { toast: toast, addToCart: addToCart, refreshCartCount: refreshCartCount };
})();
